import { useFetch } from '../useFetch/index'
import { useEffect, useState } from 'react'
import type { IAppInfo } from '@ztechapps/common.contract'

export const useAppInfo = (): { loading: boolean } & IAppInfo => {
  const [fetchNow, { loading }] = useFetch('/api/app-info', { method: 'GET' })
  const [appInfo, setAppInfo] = useState<IAppInfo>(null)

  useEffect(() => {
    fetchNow().then((result: IAppInfo) => {
      setAppInfo(result)
    })
  }, [])

  return {
    ...appInfo,
    loading,
  }
}
